export default __webpack_public_path__ + "static/media/maudsley-learning.155b8787.png";